import React from 'react';
import { Bar, BarChart, Cell, ResponsiveContainer, Tooltip, XAxis } from 'recharts';
import { P } from '../../../theme/tokens';

// Tiny 4-week bar strip used by the Analytics mini cards. Last bar is the current
// week, so it's highlighted; "Wk 1" is the oldest.
export default function WeeklyBars({ values = [], color = P.navy, unit = '', height = 96 }) {
  const data = values.map((v, i) => ({ label: `Wk ${i + 1}`, value: v }));
  const last = data.length - 1;

  if (!data.length) return null;

  return (
    <ResponsiveContainer width="100%" height={height}>
      <BarChart data={data} margin={{ top: 6, right: 4, left: 4, bottom: 0 }} barCategoryGap="28%">
        <XAxis dataKey="label" tick={{ fontSize: 10, fill: P.subtle }} tickLine={false} axisLine={false} />
        <Tooltip
          cursor={{ fill: P.rowHover }}
          contentStyle={{ borderRadius: 8, border: `1px solid ${P.border}`, fontSize: 12 }}
          formatter={(v) => [`${v}${unit ? ` ${unit}` : ''}`, 'Value']}
        />
        <Bar dataKey="value" radius={[3, 3, 0, 0]} maxBarSize={30}>
          {data.map((d, i) => (
            <Cell key={d.label} fill={i === last ? color : P.faint} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
}
